// extracted by mini-css-extract-plugin
var _1 = "ProfileActionsWidgetHideWidgetsButton-moduleicon__ZRLzJ IconNG-moduleIcon__AbXiV";
var _2 = "ProfileActionsWidgetHideWidgetsButton-modulewidgetsHidden__tcsU3";
export { _1 as "icon", _2 as "widgetsHidden" }
